import React, { useState } from 'react';
import './Industry.css';

// 2D简约图标组件
const GovernmentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M5 21V7l7-4 7 4v14" />
    <path d="M9 21v-6h6v6" />
    <path d="M10 10h.01" />
    <path d="M14 10h.01" />
  </svg>
);

const SoeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <rect x="5" y="9" width="4" height="12" />
    <rect x="10" y="5" width="4" height="16" />
    <rect x="15" y="12" width="4" height="9" />
    <path d="M7 12h.01" />
    <path d="M7 15h.01" />
    <path d="M7 18h.01" />
    <path d="M12 8h.01" />
    <path d="M12 11h.01" />
    <path d="M12 14h.01" />
    <path d="M12 17h.01" />
    <path d="M17 15h.01" />
    <path d="M17 18h.01" />
  </svg>
);

const EnterpriseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="7" r="3" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="18" r="3" />
    <path d="M12 10v3" />
    <path d="M8.5 16L10 13" />
    <path d="M15.5 16L14 13" />
  </svg>
);

const MilitaryIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l8 4v6c0 5.5-3.5 10-8 11-4.5-1-8-5.5-8-11V6l8-4z" />
    <path d="M12 8v4" />
    <path d="M12 16h.01" />
  </svg>
);

const Industry = () => {
  const [activeIndustry, setActiveIndustry] = useState('government');

  const industries = [
    { id: 'government', label: '政府部门与公共机构', icon: <GovernmentIcon /> },
    { id: 'soe', label: '国企与央企', icon: <SoeIcon /> },
    { id: 'enterprise', label: '企业组织', icon: <EnterpriseIcon /> },
    { id: 'military', label: '军工与涉密机构', icon: <MilitaryIcon /> }
  ];

  const industryData = {
    government: {
      title: '政府部门与公共机构解决方案',
      description: '为各级政府部门提供安全可信的AI办公解决方案，助力数字化转型',
      scenarios: [
        {
          title: '公文智能处理',
          desc: '公文自动校对、格式规范检查，提升公文质量',
          features: ['智能校对纠错', '格式规范检查', '政治排位校验']
        },
        {
          title: '会议智能记录',
          desc: '会议全程自动记录，生成结构化纪要，支持多部门协作',
          features: ['自动语音转写', '智能摘要生成', '任务事项追踪']
        },
        {
          title: '政策文件分析',
          desc: '政策文件智能解读、核心要点提取、汇报提纲生成',
          features: ['政策要点提取', '智能解读分析', '汇报提纲生成']
        }
      ],
      clients: [
        '上海市委网信办',
        '公安网安部门',
        '市委市政府',
        '城运中心',
        '中央及多地网信网安机构',
        '各级政府部门',
        '政务服务大厅'
      ]
    },
    soe: {
      title: '国企与央企解决方案',
      description: '为大型国有企业和央企提供企业级AI办公解决方案',
      scenarios: [
        {
          title: '合同智能管理',
          desc: '合同批量处理、版本对比、关键信息提取，降低合规风险',
          features: ['批量合同解析', '版本差异对比', '关键条款提取']
        },
        {
          title: '公文规范校对',
          desc: '符合国企公文标准，智能校验政治排位、语序逻辑',
          features: ['公文规范校验', '政治排位检查', '语序逻辑校对']
        },
        {
          title: '知识库建设',
          desc: '企业知识统一管理，智能问答检索，沉淀组织智慧',
          features: ['文档智能索引', '知识智能问答', '团队知识共享']
        }
      ],
      clients: [
        '兴业证券',
        '中国商飞',
        '上海建工',
        '电信理想',
        '上海数字化城市管理中心',
        '广西产研院'
      ]
    },
    enterprise: {
      title: '企业组织解决方案',
      description: '为各类企业和机构提供灵活高效的AI办公解决方案',
      scenarios: [
        {
          title: '智能办公助手',
          desc: '日常办公智能辅助，提升工作效率',
          features: ['文档智能处理', '会议纪要生成', '数据智能分析']
        },
        {
          title: '业务流程优化',
          desc: '业务文档自动化处理，流程智能化',
          features: ['文档自动生成', '流程智能审批', '数据智能提取']
        },
        {
          title: '知识管理平台',
          desc: '企业知识资产沉淀，智能检索利用',
          features: ['知识智能分类', '全文快速检索', '知识图谱构建']
        }
      ],
      clients: [
        '广东明思律所',
        '上海"模速空间"创新生态社区'
      ]
    },
    military: {
      title: '军工与涉密机构解决方案',
      description: '为军工及特殊机构提供高安全级别的AI办公解决方案',
      scenarios: [
        {
          title: '安全可控部署',
          desc: '完全私有化部署，数据不出域，满足最高安全要求',
          features: ['完全私有化', '数据本地化', '安全可控']
        },
        {
          title: '涉密文档处理',
          desc: '涉密文档智能处理，支持离线环境运行',
          features: ['离线运行', '涉密文档处理', '安全审计']
        },
        {
          title: '专用场景定制',
          desc: '针对特殊需求定制开发，满足专业场景要求',
          features: ['定制开发', '专业场景适配', '专属技术支持']
        }
      ],
      clients: [
        '部队及军工类部门'
      ]
    }
  };

  const currentData = industryData[activeIndustry];

  return (
    <div className="industry-page">
      {/* Hero Section */}
      <section className="industry-hero page-hero hero-tone-teal">
        <div className="page-hero-pattern"></div>
        <div className="container">
          <span className="hero-eyebrow">多行业覆盖 · 场景深度适配</span>
          <h1 className="page-title">行业应用</h1>
          <p className="page-subtitle">深耕多个行业场景，提供专业AI解决方案</p>
        </div>
      </section>

      {/* Industry Selector */}
      <section className="selector-section">
        <div className="container">
          <div className="industry-tabs">
            {industries.map(ind => (
              <button
                key={ind.id}
                className={`industry-tab ${activeIndustry === ind.id ? 'active' : ''}`}
                onClick={() => setActiveIndustry(ind.id)}
              >
                <span className="tab-icon">{ind.icon}</span>
                <span className="tab-label">{ind.label}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Detail */}
      <section className="detail-section">
        <div className="container">
          <div className="industry-header">
            <h2 className="industry-title">{currentData.title}</h2>
            <p className="industry-desc">{currentData.description}</p>
          </div>

          <div className="scenarios-grid">
            {currentData.scenarios.map((scenario, index) => (
              <div key={index} className="scenario-card">
                <h3 className="scenario-title">{scenario.title}</h3>
                <p className="scenario-desc">{scenario.desc}</p>
                <div className="feature-tags">
                  {scenario.features.map((feature, i) => (
                    <span key={i} className="feature-tag">{feature}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="clients-section">
            <h3 className="clients-title">服务客户</h3>
            <div className="clients-list">
              {currentData.clients.map((client, index) => (
                <div key={index} className="client-item">
                  <span className="client-icon">✓</span>
                  <span className="client-name">{client}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="value-section">
        <div className="container">
          <h2 className="section-title">价值主张</h2>
          <div className="value-grid">
            <div className="value-card">
              <div className="value-icon">🔒</div>
              <h3>数据安全可控</h3>
              <p>私有化部署，数据不出域，符合政企安全合规要求</p>
            </div>
            <div className="value-card">
              <div className="value-icon">⚡</div>
              <h3>效率显著提升</h3>
              <p>智能处理替代人工操作，效率提升数倍至数十倍</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>场景深度适配</h3>
              <p>针对行业特性定制优化，精准匹配业务需求</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="industry-cta">
        <div className="container">
          <h2>获取您的行业解决方案</h2>
          <p>联系我们，获取专属定制方案</p>
          <a href="/contact" className="btn btn-primary btn-lg">立即咨询</a>
        </div>
      </section>
    </div>
  );
};

export default Industry;